import { useState, useEffect, useRef } from 'react'
import { getChallenge } from '../utils/challenges'
import { IconClapper, IconCopy, IconShare } from './icons'

export default function ChallengeSent({ code, onPlayWhileWait, onOpponentJoined, onBack }) {
  const [toast, setToast] = useState('')
  const stoppedRef = useRef(false)

  useEffect(() => {
    if (!code) return
    stoppedRef.current = false

    const check = () => {
      if (stoppedRef.current) return
      const ch = getChallenge(code)
      if (ch?.p2StartActor) {
        stoppedRef.current = true
        onOpponentJoined?.(ch)
      }
    }

    const onStorage = (e) => {
      if (e.key === 'action_challenges') check()
    }

    window.addEventListener('storage', onStorage)
    const timer = setInterval(check, 1000)
    check()

    return () => {
      stoppedRef.current = true
      window.removeEventListener('storage', onStorage)
      clearInterval(timer)
    }
  }, [code])

  const copy = (text, msg) => {
    if (!navigator.clipboard) return
    navigator.clipboard.writeText(text).then(() => {
      setToast(msg)
      setTimeout(() => setToast(''), 2000)
    }).catch(() => {})
  }

  const handleCopyCode = () => copy(code, 'Code copied!')
  const handleShare = () => copy(
    `I challenged you to Action! 🎬 Enter code ${code} to accept. Think you can beat me?`,
    'Invite copied!',
  )

  return (
    <div className="challenge-sent">
      <div className={`toast ${toast ? 'toast--visible' : ''}`}>{toast || ''}</div>

      <div className="challenge-sent__content">
        <h2 className="challenge-sent__title">Challenge Sent! <IconClapper size={18} style={{ verticalAlign: 'middle' }} /></h2>
        <p className="challenge-sent__sub">Share this code with your opponent</p>

        <div className="challenge-sent__code-box">
          <span className="challenge-sent__code">{code}</span>
        </div>

        <div className="challenge-sent__actions">
          <button type="button" className="btn-primary challenge-sent__btn" onClick={handleCopyCode}>
<IconCopy size={15} style={{ verticalAlign: 'middle' }} /> Copy Code
          </button>
          <button type="button" className="btn-primary challenge-sent__btn" onClick={handleShare}>
<IconShare size={15} style={{ verticalAlign: 'middle' }} /> Share
          </button>
          <button type="button" className="btn-primary challenge-sent__btn challenge-sent__btn--play" onClick={onPlayWhileWait}>
<IconClapper size={15} style={{ verticalAlign: 'middle' }} /> Play While You Wait
          </button>
          {onBack && (
            <button type="button" className="btn-ghost" onClick={onBack}>
              Back
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
